import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EyeOutlinedSvg from "@ant-design/icons-svg/es/asn/EyeOutlined";
import AntdIcon from "../components/AntdIcon";
var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EyeOutlined.displayName = 'EyeOutlined';
}
export default /*#__PURE__*/React.forwardRef(EyeOutlined);